import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {InsuranceCompany} from '../../../../shared/interface/insurance-company';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {catchError, mapTo, tap} from 'rxjs/operators';
import {Uuid} from '../../../../shared/interface/response/uuid';
import {of} from 'rxjs';
import {ThresholdDictionary} from '../../../../shared/interface/threshold-dictionary';
import {ThresholdService} from '../../../../shared/services/threshold.service';
import {Dictionary} from '../../../../shared/interface/dictionary';

export interface EditThresholdDictionaryModalData {
  thresholdDictionary: ThresholdDictionary;
}

@Component({
  selector: 'app-edit-threshold-modal',
  templateUrl: './edit-threshold-modal.component.html',
  styleUrls: ['./edit-threshold-modal.component.scss']
})
export class EditThresholdModalComponent implements OnInit {

  thresholdDictionaryObject: ThresholdDictionary;
  thresholdForm: FormGroup;
  importerControl: FormControl;
  insuranceCompanyControl: FormControl;
  policyTypesControl: FormControl;
  nameControl: FormControl;
  processingRequest = false;
  selectedInsuranceCompany: InsuranceCompany;

  constructor(
    public dialogRef: MatDialogRef<EditThresholdModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditThresholdDictionaryModalData,
    private fb: FormBuilder,
    private thresholdService: ThresholdService,
    private snack: MatSnackBar,
  ) {
    this.thresholdDictionaryObject = data.thresholdDictionary;
    this.selectedInsuranceCompany = data.thresholdDictionary.insuranceCompany;
    this.thresholdForm = fb.group({
      name: this.nameControl = fb.control('', [Validators.required]),
      importer: this.importerControl = fb.control(''),
      insuranceCompany: this.insuranceCompanyControl = fb.control('', [Validators.required]),
      policyTypes: this.policyTypesControl = fb.control([]),
    });
  }

  ngOnInit(): void {
    this.thresholdForm.setValue({
      name: this.thresholdDictionaryObject?.name ?? '',
      importer: this.thresholdDictionaryObject?.importer?.id ?? '',
      insuranceCompany: this.thresholdDictionaryObject?.insuranceCompany?.id ?? '',
      policyTypes: this.thresholdDictionaryObject?.policyTypes?.map((policyType: Dictionary) => policyType.id) ?? [],
    });
  }

  save(): void {
    this.processingRequest = true;
    this.thresholdService
      .sendForm(this.thresholdForm.value, this.thresholdDictionaryObject.uuid)
      .pipe(
        tap(() => this.processingRequest = false),
        tap((response: Uuid) => this.dialogRef.close(response.uuid)),
        mapTo('Pomyślnie zaktualizowano próg'),
        catchError(() => {
          this.processingRequest = false;
          return of('Podczas przesyłania formularza wystąpił błąd');
        })
      )
      .subscribe((message: string) => {
        this.snack.open(message, '', {
          duration: 2000,
        });
      });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  insuranceCompanyChanged(insuranceCompany: InsuranceCompany): void {
    this.selectedInsuranceCompany = insuranceCompany;
  }
}
